import { render, staticRenderFns } from "./ShifttypetaskFields.vue?vue&type=template&id=0c372a4b"
import script from "./ShifttypetaskFields.vue?vue&type=script&lang=js"
export * from "./ShifttypetaskFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports